module.exports = __webpack_public_path__ + "static/media/browse_project_main_image.c7c24bda.svg";